import { render, staticRenderFns } from "./ProjectsOrderCard.vue?vue&type=template&id=398831d4&scoped=true&v-if=projects"
import script from "./ProjectsOrderCard.vue?vue&type=script&lang=js"
export * from "./ProjectsOrderCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectsOrderCard.vue?vue&type=style&index=0&id=398831d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398831d4",
  null
  
)

export default component.exports